<template>
    <Header v-if="!showOnlyContent" @phoneChanged="handlePhoneChange" />
    <template v-if="showOnlyContent">
        <router-view></router-view>
    </template>
    <template v-else>
        <main class="mapp-main">
            <SubHeader ref="subHeaderRef" :subHeaderData="subHeaderData" @statusUpdated="fixableSubheader = true" />
            <div class="mapp-main__content container-fluid container-xl">
                <router-view></router-view>
            </div>
        </main>
    </template>

    <Footer v-if="!showOnlyContent" :currentPhone="currentPhone" />
    <CookieNotice v-if="!showOnlyContent" />

    <!-- AmoCRM button -->
    <!-- <script>
            window.amoSocialButtonConfig = {
                hidden: false,
                color: '#4bace3',

                onlinechat: {
                    mode: 'widget',
                    user_id: '',

                    locale: {
                        extends: 'ru',
                        compose_placeholder: 'Напишите ваш вопрос...',
                    },

                    theme: {
                        header: false,
                    },
                },
            };
        </script> -->
    <!-- <script>
        (function (a, m, o, c, r, m) {
            a[m] = {
                id: '426211',
                hash: '65c910c6af79da4b7a2d2a3d900d8a11ebbbcccbe47e0d1843bb542d427d8e98',
                locale: 'ru',
                inline: false,
                setMeta: function (p) {
                    this.params = (this.params || []).concat([p]);
                },
            };
            a[o] =
                a[o] ||
                function () {
                    (a[o].q = a[o].q || []).push(arguments);
                };
            var d = a.document,
                s = d.createElement('script');
            s.async = true;
            s.id = m + '_script';
            s.src = 'https://gso.amocrm.ru/js/button.js';
            d.head && d.head.appendChild(s);
        })(window, 0, 'amoSocialButton', 0, 0, 'amo_social_button');
    </script> -->
    <!-- /AmoCRM button -->
</template>

<script>
import Header from './components/Header.vue';
import SubHeader from './components/SubHeader.vue';
import Footer from './components/Footer.vue';
import CookieNotice from './components/CookieNotice.vue';
import tools from './assets/js/tools.js';

export default {
    components: {
        Header,
        Footer,
        CookieNotice,
        SubHeader,
    },

    data() {
        return {
            subHeaderData: '',
            showOnlyContent: tools.isShowOnlyContent(),
            currentPhone: {
                link: 'tel:84951654112',
                text: '8 (495) 165-4-112',
            },
            fixedSubheader: false,
            previousScroll: window.top.scrollY,
            actualDocumentWidth: null,
            HEADER: null,
            SUBHEADER: null,
            MAIN: null,
        };
    },

    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.actualDocumentWidth = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight
        );
        this.HEADER = document.querySelector('.mapp-header');
        this.SUBHEADER = document.querySelector('.mapp-subheader');
        this.MAIN = document.querySelector('.mapp-main');

        if (!this.showOnlyContent) {
            const initConfigScript = document.createElement('script');
            initConfigScript.innerHTML = `window.amoSocialButtonConfig={hidden:!1,color:"#4bace3",onlinechat:{mode:"widget",user_id:"",locale:{extends:"ru",compose_placeholder:"Напишите ваш вопрос..."},theme:{header:!1}}};`;

            document.body.appendChild(initConfigScript);

            const initWidgetScript = document.createElement('script');
            initWidgetScript.innerHTML = `!function(a,t,c,e,n,t){a[t]={id:"426211",hash:"65c910c6af79da4b7a2d2a3d900d8a11ebbbcccbe47e0d1843bb542d427d8e98",locale:"ru",inline:!1,setMeta:function(a){this.params=(this.params||[]).concat([a])}},a[c]=a[c]||function(){(a[c].q=a[c].q||[]).push(arguments)};var s=a.document,o=s.createElement("script");o.async=!0,o.id=t+"_script",o.src="https://gso.amocrm.ru/js/button.js",s.head&&s.head.appendChild(o)}(window,0,"amoSocialButton",0,0,"amo_social_button");`;

            document.body.appendChild(initWidgetScript);
        }
    },

    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
        handleScroll() {
            let currentScroll = window.top.scrollY;

            if (this.actualDocumentWidth >= 768) {
                // only fix
                if (currentScroll > 0) {
                    if (document.body.classList.contains('fixed')) {
                        return;
                    }
                    document.body.classList.add('fixed');
                    // this.HEADER.style.transform = `translateY(-${this.HEADER.offsetHeight}px)`;
                    // this.SUBHEADER.style.top = `0px`;
                    this.MAIN.style.marginTop = this.HEADER.offsetHeight + 'px';
                }

                // if (currentScroll > this.HEADER.offsetHeight && currentScroll > this.previousScroll) {
                //     document.body.classList.add('animated');
                // }
                else if (currentScroll <= 0) {
                    document.body.classList.remove('fixed');
                    // this.HEADER.style.transform = `translateY(0px)`;

                    // this.SUBHEADER.style.top = `${this.HEADER.offsetHeight}px`;
                    this.MAIN.style.marginTop = '0px';
                }
            } else {
                if (currentScroll > this.HEADER.offsetHeight) {
                    document.body.classList.add('fixed', 'collapsed');
                    this.HEADER.style.transform = `translateY(-${this.HEADER.offsetHeight}px)`;
                    this.SUBHEADER.style.top = `0px`;
                    this.MAIN.style.marginTop = this.HEADER.offsetHeight + 'px';
                }

                if (currentScroll > this.HEADER.offsetHeight && currentScroll > this.previousScroll) {
                    document.body.classList.add('animated');
                } else if (currentScroll <= 0) {
                    document.body.classList.remove('fixed', 'collapsed', 'animated');
                    this.HEADER.style.transform = `translateY(0px)`;

                    this.SUBHEADER.style.top = `${this.HEADER.offsetHeight}px`;
                    this.MAIN.style.marginTop = '0px';
                } else {
                    this.HEADER.style.transform = `translateY(0px)`;
                    this.SUBHEADER.style.top = `${this.HEADER.offsetHeight}px`;

                    document.body.classList.remove('collapsed');
                }
            }

            this.previousScroll = currentScroll;
        },
        setSubHeaderPercent(status, value) {
            this.$refs.subHeaderRef.setSubHeaderPercent(status, value);
        },

        setSubHeaderTitle(value) {
            this.$refs.subHeaderRef.setSubHeaderData(value);
        },

        handlePhoneChange(data) {
            this.currentPhone = data;
        },
    },
};
</script>
<style>
@import './assets/css/header.css';
@import './assets/css/general.css';
@import './assets/css/animate.css';

.leaflet-attribution-flag {
    visibility: hidden !important;
}
</style>

<style src="leaflet/dist/leaflet.css"></style>
